import { CoveoContext } from '../coveo/components/context';
import {
  defaultTab,
  filtersPerFacetValue
} from '../coveo/controllers/controller';

export const getFacetKeyFromHash = (targetKey: string) => {
  const hash = window.location.hash.slice(1); // Remove '#'
  const params = new URLSearchParams(hash);

  for (const [key, value] of params.entries()) {
    if (key === `f-${targetKey}`) {
      return { key, value };
    }
  }

  return null;
};

export const clearAllFacetsContext = () => {
  if (filtersPerFacetValue && filtersPerFacetValue?.length > 0) {
    filtersPerFacetValue.forEach(facet => {
      const { context, tab } = facet;
      const coveoContext = CoveoContext();

      if (context) {
        const keys = Object.keys(context);
        keys.forEach(key => coveoContext?.remove(key));
      }

      if (tab) {
        defaultTab?.select();
      }
    });
  }
};
